import { Contact } from '@/api/freedomQl/__generated__/graphql';
import { IntegraAccountSettings } from '@/api/integraLink/types';
import { YES } from '@/config/constants';
import { getAccountWebSettingsByAccountRef } from '@/api/freedomQl';
import { getIntegraAccount } from '@/utils/helpers';
import logger from './logger';

export const getAccountWebSettings = async (
  contact: Contact,
  isMasquerading: boolean,
): Promise<IntegraAccountSettings | undefined> => {
  try {
    if (!contact.accountRef) return undefined;

    const settings = isMasquerading
      ? await getRemoteAccountSettings(contact.accountRef)
      : getLocalAccountSettings(contact.accountRef);

    return settings;
  } catch (e: any) {
    logger.error('getAccountWebSettings', e.message ?? e);
  }
};

const getLocalAccountSettings = (
  accountRef: string,
): IntegraAccountSettings | undefined => {
  const integraAccount = getIntegraAccount(accountRef);
  if (!integraAccount) return undefined;

  const { priceIncTax, defaultContactIsPassenger, signupDefaultGroupRef } =
    integraAccount;
  return { priceIncTax, defaultContactIsPassenger, signupDefaultGroupRef };
};

const getRemoteAccountSettings = async (
  accountRef: string,
): Promise<IntegraAccountSettings> => {
  const fqlSettings = await getAccountWebSettingsByAccountRef(accountRef);

  return {
    priceIncTax: fqlSettings.priceIncTax === YES,
    defaultContactIsPassenger: fqlSettings.defaultContactIsPassenger === YES,
    signupDefaultGroupRef: fqlSettings.signupDefaultGroupRef,
  };
};
